import { render } from "./NotFoundPage.vue?vue&type=template&id=8e367c50"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/NotFoundPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8e367c50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8e367c50', __exports__)) {
    api.reload('8e367c50', __exports__)
  }
  
  module.hot.accept("./NotFoundPage.vue?vue&type=template&id=8e367c50", () => {
    api.rerender('8e367c50', render)
  })

}


export default __exports__